import { ContractConceptRelationshipState, ContractConceptRelationshipUnloadState } from '../../states/ContractConceptRelationship.State';
import { ContractConceptRelationship } from '../../../models/Entities/Contracts/ContractConceptRelationship';
import * as actions from '../../actions/ContractConceptRelationship.Actions';

export default function ContractConceptRelationshipCreateReducer(
  state: ContractConceptRelationshipState | undefined,
  action: any
): ContractConceptRelationshipState {
  const currentState = state ?? ContractConceptRelationshipUnloadState;
  switch (action.type) {
    case actions.CONTRACT_CONCEPT_REL_CREATE_REQUEST:
      return {
        ...currentState,
        isAddingNewOne: true,
        successAddingNewOne: undefined,
        failOnAddingNewOne: false,
        error: undefined,
      };
    case actions.CONTRACT_CONCEPT_REL_CREATE_SUCCESS:
      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: true,
        failOnAddingNewOne: false,
        list: [...(currentState.list || []), ...action.relationShip || [] as ContractConceptRelationship[]]
      };
    case actions.CONTRACT_CONCEPT_REL_CREATE_FAILURE:
      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: false,
        failOnAddingNewOne: true,
        error: action.error,
      };
    default:
      return currentState;
  }
}
